var _slicedToArray = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _get = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _getPrototypeOf = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _require = require('orange-svg'),
  OrangeSVGRect = _require.OrangeSVGRect;
var OrangeChartAbstractXY = require('./orange-chart-abstract-x-y');
var OrangeChartAbstractBars = /*#__PURE__*/function (_OrangeChartAbstractX) {
  "use strict";

  _inherits(OrangeChartAbstractBars, _OrangeChartAbstractX);
  var _super = _createSuper(OrangeChartAbstractBars);
  function OrangeChartAbstractBars() {
    _classCallCheck(this, OrangeChartAbstractBars);
    return _super.apply(this, arguments);
  }
  _createClass(OrangeChartAbstractBars, [{
    key: "chart_sub_type_code",
    get:
    /**
     * @abstract
     * @return string
     */
    function get() {
      throw new Error('OrangeChartAbstractBars.chart_sub_type_code should be overridden');
    }

    /**
     * Returns chart elements positioning mode
     * @return boolean
     */
  }, {
    key: "_is_vertical",
    get: function get() {
      return this.chart_sub_type_code === 'vertical';
    }

    /**
     * Returns allowed axes for the chart
     *
     * @type {string[]}
     * @static
     */
  }, {
    key: "_get_basic_dimensions",
    value:
    /**
     * Basic dimensions of the chart
     *
     * @param {object} view
     * @return {{width:number, height:number}}
     * @protected
     */
    function _get_basic_dimensions(view) {
      var bar_size = view.hasOwnProperty('bar_size') ? view.bar_size : 60;
      var margin = view.hasOwnProperty('margin') ? view.margin : 20;
      var width = view.hasOwnProperty('width') ? view.width : !this._is_vertical ? this._data.length * (margin + bar_size) + margin : 500;
      var height = view.hasOwnProperty('height') ? view.height : this._is_vertical ? this._data.length * (margin + bar_size) + margin : 200;
      return {
        width: width,
        height: height
      };
    }

    /**
     *
     * @param {number} total_length
     * @param {object} view
     * @param {boolean=false} has_label
     * @return {{bar_size: number, margin: number, side_margin_adjustment: number}}
     * @protected
     */
  }, {
    key: "_calculate_data_for_render",
    value: function _calculate_data_for_render(total_length, view) {
      var has_label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var margin = view.hasOwnProperty('margin') ? view.margin : 20;
      var bar_size = view.hasOwnProperty('bar_size') ? view.bar_size : 60;
      var m_bw_ratio = margin / bar_size;
      var side_margin_adjustment = has_label ? 1 : -1;
      margin = total_length / (this._data.length + side_margin_adjustment + this._data.length / m_bw_ratio);
      bar_size = margin / m_bw_ratio;
      return {
        bar_size: bar_size,
        margin: margin,
        side_margin_adjustment: side_margin_adjustment
      };
    }

    /**
     * Renders chart
     *
     * @param {OrangeSVG} svg
     * @param {object} view
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @protected
     */
  }, {
    key: "_do_render",
    value: function _do_render(svg, view, x1, y1, x2, y2) {
      _get(_getPrototypeOf(OrangeChartAbstractBars.prototype), "_do_render", this).call(this, svg, view, x1, y1, x2, y2);
      var width = x2 - x1;
      var height = y2 - y1;
      var real_axis = this._is_vertical ? this._axes.y : this._axes.x;
      var rd = this._calculate_data_for_render(this.chart_sub_type_code === 'vertical' ? width : height, view, real_axis._config.label);
      var fair = view.hasOwnProperty('fair') ? view.fair : false;
      var bar_length, row_cumulative_value;
      var real_scale = real_axis.scale;
      for (var _i = 0, _Object$entries = Object.entries(this._data); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          i = _Object$entries$_i[0],
          row = _Object$entries$_i[1];
        i = parseInt(i);
        var bar_section_length = real_axis.cumulative ? rd.bar_size : rd.bar_size / this._source_mapping.length;
        row_cumulative_value = 0;
        for (var _i2 = 0, _Object$entries2 = Object.entries(this._source_mapping); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            j = _Object$entries2$_i[0],
            bar = _Object$entries2$_i[1];
          if (!bar.hasOwnProperty('property')) {
            throw new Error('"property" should be defined for "bar" in properties');
          }
          j = parseInt(j);
          var callbacks = this.getCallbacks(bar.property);
          var callback_data = {
            'property': bar.property,
            'value': row[bar.property]
          };
          var rsv = row[bar.property] - real_scale.min;
          var rss = real_scale.max - real_scale.min;
          bar_length = this._axes.y._config.dynamic && this._axes.y._config.log ? rsv ? Math.log(rsv) / Math.log(rss) : 0 : rsv / rss;
          bar_length = bar_length * (this._is_vertical ? height : width);
          var unfair_adjustment = real_axis.cumulative && !fair && j && row_cumulative_value ? Math.min(row_cumulative_value, height * 0.0075) : 0;
          var rectangle = this._is_vertical ? new OrangeSVGRect((rd.margin + rd.bar_size) * i + (real_axis.cumulative ? 0 : bar_section_length * j) + (rd.side_margin_adjustment > 0 ? rd.margin : 0) + x1, height - bar_length - row_cumulative_value + y1, bar_section_length, bar_length + unfair_adjustment, bar.color) : new OrangeSVGRect(row_cumulative_value + x1, (rd.margin + rd.bar_size) * i + (real_axis.cumulative ? 0 : bar_section_length * j) + (rd.side_margin_adjustment > 0 ? rd.margin : 0) + y1, bar_length + unfair_adjustment, bar_section_length, bar.color);
          rectangle.args = {
            'data-property': bar.property,
            'class': "orange-chart-bars-bar, orange-chart-bars-bar-".concat(this.chart_sub_type_code)
          };
          svg.appendChild(rectangle, callbacks, callback_data);
          if (real_axis.cumulative) {
            row_cumulative_value += bar_length;
          }
        }
      }
    }
  }], [{
    key: "chart_type_code",
    get:
    /**
     * Chart type
     *
     * @type {string}
     * @static
     */
    function get() {
      return 'bars';
    }
  }, {
    key: "allowed_axes",
    get: function get() {
      return ['x', 'y'];
    }
  }]);
  return OrangeChartAbstractBars;
}(OrangeChartAbstractXY);
module.exports = OrangeChartAbstractBars;